import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApiBackendClient } from '../../helpers/api_backend_helper';
import { GET_ST_VEHICU } from '../../helpers/url_helper';

const useCreateVehiculo = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const apiBackendClient = new ApiBackendClient();

    const createVehiculo = async (datosVehiculo) => {
        setLoading(true);
        setError(null);
        try {
            console.log('Datos a guardar:', datosVehiculo);
            const response = await apiBackendClient.create(`${GET_ST_VEHICU}?tenantId=${tenantId}`, {
                vehicleData: datosVehiculo,
                tenantId,
                empresa,
                departamento,
                usuario: userInfo?.name
            });
            console.log('Response from API:', response);
            if (response.CLACLI) {
                const result = response;
                console.log('Vehículo creado con éxito:', result);
                return { success: true, data: result };
            } else {
                throw new Error(response.message || 'Error al guardar el vehículo');
            }
        } catch (err) {
            const errorMessage = `Failed to create vehiculo: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { createVehiculo, loading, error };
};

export default useCreateVehiculo;